// extracted by mini-css-extract-plugin
export default {"main":"EntityDossier_main__4UN4n","header":"EntityDossier_header__B4ZR2","divider":"EntityDossier_divider__OwiLu","content":"EntityDossier_content__zoBB7"};